/**
 * Esta función tiene como propósito validar que todas las tarjetas
 * introducidas sean del emisor correcto y tengan la longitud esperada.
 * Las tarjetas que se emiten son únicamente Visa, pero se agrega
 * validación para MasterCard en caso de que se emitan también tarjetas MC
 * 
 * @param card Un número de tarjeta cualquiera
 */

export function validateTarjeta(card: string) {
  // La tarjeta debe ser Visa o MasterCard y contener 16 dígitos
  const visaRegex = /^(?:4[0-9]{15})$/
  const masterCardRegex = /^(?:5[0-9]{15})$/
  if (visaRegex.test(card) || masterCardRegex.test(card)) {
    // Algoritmo de Luhn https://es.wikipedia.org/wiki/Algoritmo_de_Luhn
    let sum = 0;
    let digit = 0;
    for (let i = card.length - 1; i >= 0; i--) {
      digit = Number(card.charAt(i));
      if (i % 2 === 0) {
        digit *= 2
      }
      if (digit > 9) {
        digit -= 9;
      }
      sum += digit;
    }
    return (sum % 10) === 0;
  }
  return false;
}